export const ROUTE_CONSTANTS = {
   Login: '/',
   BOARD: '/board'
}
